import { render, staticRenderFns } from "./ResidentDetailTab.vue?vue&type=template&id=34666bd3&scoped=true&lang=pug"
import script from "./ResidentDetailTab.vue?vue&type=script&lang=ts"
export * from "./ResidentDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./ResidentDetailTab.vue?vue&type=style&index=0&id=34666bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34666bd3",
  null
  
)

export default component.exports